export const colors: [string, string, string][] = [
    ["Red Orange", "bg-[#FF5733]", "#FF5733"],
    ["Green", "bg-[#33FF57]", "#33FF57"],
    ["Blue", "bg-[#3357FF]", "#3357FF"],
    ["Pink", "bg-[#FF33A8]", "#FF33A8"],
    ["Yellow Orange", "bg-[#FFBD33]", "#FFBD33"],
    ["Purple", "bg-[#8D33FF]", "#8D33FF"],
    ["Cyan", "bg-[#33FFF6]", "#33FFF6"],
    ["Red", "bg-[#FF3333]", "#FF3333"],
    ["Teal", "bg-[#33FFBD]", "#33FFBD"],
    ["Violet", "bg-[#A833FF]", "#A833FF"],
    ["Orange", "bg-[#FFA733]", "#FFA733"],
    ["Light Green", "bg-[#57FF33]", "#57FF33"],
    ["Sky Blue", "bg-[#339FFF]", "#339FFF"],
    ["Rose", "bg-[#FF3380]", "#FF3380"],
    ["Deep Purple", "bg-[#C733FF]", "#C733FF"],
    ["Coral", "bg-[#FF5733]", "#FF5733"],
    ["Light Blue", "bg-[#33A1FF]", "#33A1FF"],
    ["Golden Yellow", "bg-[#FFD433]", "#FFD433"],
    ["Magenta", "bg-[#FF3399]", "#FF3399"],
    ["Mint Green", "bg-[#33FF99]", "#33FF99"],
  ];